import type { DealerCustomer, PendingUser } from "@/gql/graphql";
import { OptInStatus, UserRole } from "@/gql/graphql";

export const canRequestOptIn = (
  customer: Pick<DealerCustomer, "optInStatus"> | null
) => {
  return (
    customer?.optInStatus !== OptInStatus.Approved &&
    customer?.optInStatus !== OptInStatus.Requested
  );
};

export const isCustomerOptedIn = (
  customer: Pick<DealerCustomer, "optInStatus"> | null | undefined
) => {
  return customer?.optInStatus === OptInStatus.Approved;
};

export const hasCustomerOwner = (
  users: readonly Pick<PendingUser, "role">[]
): boolean => users.some((user) => user.role === UserRole.Owner);

// Alphabetically first email is the primary owner we show
export const getPrimaryOwner = <T extends Pick<PendingUser, "email" | "role">>(
  users: readonly T[] | null | undefined
): T | undefined =>
  (users ?? [])
    .filter((user) => user.role === UserRole.Owner)
    .sort((a, b) => a.email.localeCompare(b.email))[0];
